<template>
   <div class="container">
    <section id="editContent" class="columnContainer settingPage smartVoiceEdit">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.smartvoice}}</h1>
        <div class="flexBox">
          <div class="flexInner">
            <div class="innerItem">
              <div class="addGroup mb15">
                <input type="text" class="input" v-model="newGroup" @keyup.enter="addGroup">
                <button type="type" class="btnAddGroup" :disabled="disabledAddGroup" @click="addGroup">+</button>
              </div>
              <List v-if="list && list.length"
                :locale="locale"
                :list="list"
                :active="item && item.id"
                @setItem="setItem" />
              <p v-else class="nodata">{{locale.smartvoice_group_nodata}}</p>
            </div>
          </div>
          <div class="flexInner" data-flex="4">
            <div id="smartVoiceItemBox" class="innerItem">
              <Item v-if="item && item.id"
                :item="item"
                :locale="locale"
                :voiceInfo="voiceInfo"
                @setItem="setItem"
                @updateGroup="updateGroup"
                @deleteGroup="deleteGroup" />
              <p v-else class="nodata">{{locale.smartvoice_group_noselection}}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
   </div>
</template>

<script>
import regExp from '@/common/regExp'
import List from '@/components/SmartVoice/List'
import Item from '@/components/SmartVoice/Item'

export default {
  name: 'SmartVoice',
  props: [
    'locale',
    'groupId'
  ],
  components: {
    List,
    Item
  },
  computed: {
    disabledAddGroup () {
      return regExp.replaceAllEmpty(this.newGroup).length <= 0
    }
  },
  created () {
    const groupId = this.groupId
    this.$store.commit('onLoading', true)
    this.$store.dispatch('smartvoice/getVoiceInfo').then((res) => {
      if (res) {
        this.voiceInfo = Object.keys(res).map(x => {
          return {
            code: x,
            country: res[x].country,
            voices: Object.keys(res[x].voices).map(v => {
              return res[x].voices[v]
            })
          }
        }).sort((a, b) => {
          return a.country < b.country ? -1 : 1
        })
      }
      this.$store.commit('onLoading', false)
    })
    this.getGroup().then((res) => {
      this.setItem(groupId || res[0].groupId)
      this.$store.commit('onLoading', false)
    })
  },
  data () {
    return {
      list: [],
      item: null,
      voiceInfo: null,
      newGroup: ''
    }
  },
  methods: {
    async getGroup (isInit) {
      return this.$store.dispatch('smartvoice/getGroups').then((res) => {
        if (res && res.length) {
          const list = res.map(x => x).sort((a, b) => {
            return a.createat > b.createat ? -1 : 1
          })
          this.list = list
          return list
        } else {
          return res
        }
      })
    },
    setItem (groupId) {
      if (groupId) {
        const group = this.list && this.list.find(x => x.groupId === groupId)
        const groupName = group && group.groupName
        const defaultVoice = group && group.defaultVoice
        this.newGroup = ''
        this.item = null
        this.$router.replace({ params: { groupId: groupId } })
        this.$store.dispatch('smartvoice/getGroupItem', groupId).then((res) => {
          if (res) {
            this.item = {
              id: groupId,
              groupName: groupName,
              defaultVoice: defaultVoice,
              detail: res.map(x => {
                return {
                  ...x,
                  speed: x.speed || 1.0,
                  pitch: x.pitch || 1.0
                }
              })
            }
          } else {
            this.$store.commit('onLoading', false)
          }
        })
      }
    },
    addGroup () {
      const newGroup = this.newGroup
      this.$store.commit('onLoading', true)
      this.$store.dispatch('smartvoice/createGroup', newGroup).then((res) => {
        if (res) {
          this.newGroup = ''
          this.getGroup().then((res) => {
            const groupId = this.list[0].groupId
            this.setItem(groupId)
            this.$store.commit('onLoading', false)
          })
        } else {
          this.$store.commit('onLoading', false)
        }
      })
    },
    deleteGroup (groupId) {
      this.$store.commit('onLoading', true)
      this.$store.dispatch('smartvoice/deleteGroup', groupId).then((res) => {
        if (res) {
          alert(this.locale.complete_delete)
          setTimeout(() => {
            this.getGroup().then((res) => {
              this.setItem(res[0].groupId)
              this.$store.commit('onLoading', false)
            })
          }, 500)
        } else {
          this.$store.commit('onLoading', false)
        }
      })
    },
    updateGroup (data) {
      this.$store.commit('onLoading', true)
      this.$store.dispatch('smartvoice/updateGroup', data).then((res) => {
        if (res) {
          alert(this.locale.complete_modify)
          setTimeout(() => {
            this.getGroup().then((res) => {
              this.setItem(data.groupId)
              this.$store.commit('onLoading', false)
            })
          }, 500)
        } else {
          this.$store.commit('onLoading', false)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#editContent.columnContainer {
  .innerColumn {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .innerSide {
    width: 300px;
  }
  .sideBox {
    margin-left: 0;
    padding-left: 0;
  }
  .flexBox {
    flex: 1;
    overflow: hidden;
  }
  .flexInner {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .innerItem {
    flex: 1;
    overflow: auto;
    margin-bottom: 0;
  }
}
</style>
